//import React components
import PropTypes from "prop-types";
import {useAppState} from "../../../../context/state.js";
import {default as InfoElem} from "./SideControlElement.js";

//import components


//Props settings for SideControlInfo
SideControlInfo.propTypes = {

}

SideControlInfo.defaultProps = {

}

export default function SideControlInfo ({...props}) {
    const [appState] = useAppState();

    return (
        <div className={"sideControl_info"}>
            <div className={"userInfo"}>
                <div className={"sideControl-heading"}>
                    <p className={"h3"}>Brukerprofil</p>
                </div>
                <InfoElem
                    className={"userInfo-name"}
                    label={"Navn"}
                    info={appState.user.name}/>
                <InfoElem
                    className={"userInfo-email"}
                    label={"E-post"}
                    info={appState.user.email}/>

                <InfoElem
                    className={"userInfo-mobile"}
                    label={"Mobilnummer"}
                    info={`${appState.user.country_code} ${appState.user.mobile}`}/>
            </div>
        </div>
    )
}
